import { Container } from "./Elements";

import logoSam from './../img/arnastofnun_svart_logo.svg';
import logoThjs from './../img/thjodskjalasafn_logo.png';
import logoNasjonal from './../img/nasjonalarkivet_logo.svg';
import logoKu from './../img/ku_logo.png';
import logoApmf from './../img/apmf_logo.svg';

function SiteFooter(props) {
	return 	<div className="mt-20 border-t bg-gray-50">
		<Container className="pt-20 pb-24">

			<div className="md:flex gap-20 items-center mb-10">
				<img className="max-h-[70px]" src={logoSam} />
				<img className="max-h-[60px]" src={logoThjs} />
				<img className="max-h-[70px]" src={logoNasjonal} />
				<img className="max-h-[90px]" src={logoKu} />
			</div>

			<p>{window.l('The project was funded with a grant from')} <strong>A.P. Møller og Hustru Chastine Mc-Kinney Møllers Fond til almene Formaal (A.P. Møller Fonden).</strong></p>

			<div><img className="max-w-[300px] mt-6" src={logoApmf} /></div>

		</Container>
	</div>
}

export default SiteFooter;